<template>
  <div class="flex flex-col">
    <div class="w-full px-4 py-6 flex-auto text-center">
      <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
    </div>
  </div>
</template>
<script>
export default {
    name: "StoryPrompt"
}
</script>
<style scoped>
    
</style>